/*
 * @Author: zhangcongcong zhangcongcong@move2newidea.com
 * @Date: 2023-08-18 17:52:39
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-04-29 09:55:40
 * @FilePath: /memo-web/src/router/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Login from '../pages/login'
import Home from '../pages/home'
import Baidu from '../pages/baidu'
import Memo from '../pages/memoX6'
import Gantt from '../pages/gantt'
import View from '../pages/view'
import CalendarView from '../pages/calendar'
import Schedule from '../pages/calendar/schedule'
import TaskKanban from '../pages/taskKanban'
import Auth from '../pages/auth'
import DocumentLibrary from '../components/documentLibrary'
import testPage from '../components/memos/onlyoffice'


export const routes = [
    {
        path: "/",
        component: Home,
        exact: true
    },
    {
        path: "/auth_baidu",
        component: Baidu,
        exact: true
    },
    {
        path: "/login",
        component: Login,
        exact: true
    },
    {
        path: "/auth",
        component: Auth,
        exact: true
    },
    {
        path: "/memo",
        component: Memo,
        exact: true
    }, {
        path: "/gantt",
        component: Gantt,
        exact: true
    }, {
        path: "/view",
        component: View,
        exact: true
    },
    {
        path: "/calendar/:data",
        component: CalendarView,
        exact: true
    },
    {
        path: "/taskKanban",
        component: TaskKanban,
        exact: true
    },
    {
        path: "/schedule/:dataType/:data",
        component: Schedule,
        exact: true
    },
    {
        path: '/documentLibrary',
        component: DocumentLibrary,
        exact: true
    },
    {
        path: '/test',
        component: testPage,
        exact: true
    }
]
